<template>
  <div>
    <div class="form__top">
      <div class="form__stats" v-if="showCounter">
        <div class="w-55">
          <div class="coundown">
            <div class="day">
              <span class="number">{{ days }}</span>
              <span class="format">d</span>
            </div>
            <div class="hour">
              <span class="number">{{ hours }}</span>
              <span class="format">g</span>
            </div>
            <div class="min">
              <span class="number">{{ minutes }}</span>
              <span class="format">m</span>
            </div>
          </div>
        </div>
        <div class="w-45 form__counter-box">
          <span> {{ counterData }} </span>
          <img
            class="form__bee-counter"
            src="../assets/images/i_bee-times.svg"
            alt="pszczoła"
          />
        </div>
      </div>
      <div v-if="!showCounter">
        <div class="form__text">
          Adoptowane pszczoły:
        </div>
        <div class="form__bold">
          {{ counterData }}
        </div>
        <div class="form__text">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CountDown",
  props: ["starttime", "endtime", "counterData"],
  data() {
    return {
      title: "countdown",
      timer: "",
      start: "",
      end: "",
      interval: "",
      days: "",
      minutes: "",
      hours: "",
      seconds: "",
      showCounter: true,
    };
  },
  mounted() {
    this.start = new Date(this.starttime).getTime();
    this.end = new Date(this.endtime).getTime();
    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end, this.start, this.end);
    }, 36000);

  
  },
  methods: {
    timerCount: function(start, end) {
      var now = new Date().getTime();

      var distance = start - now;
      var passTime = end - now;

      if (distance < 0 && passTime < 0) {
        clearInterval(this.interval);
        this.showCounter = false;
        return;
      } else if (distance < 0 && passTime > 0) {
        this.showCounter = true;
        this.calcTime(passTime);
      } else if (distance > 0 && passTime > 0) {
        this.calcTime(distance);
      }
    },
    calcTime: function(dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    },
  },
};
</script>
